import lodash from 'lodash'
export default {
  getListFAQ (state, payload) {
    // var data = []
    // state.list_faq = []
    state.list_faq = payload.data ? payload.data : payload
    // data.forEach(element => {
    //   state.list_faq.push(rederData(element))
    // })
    state.last_page = payload.meta ? payload.meta.last_page : 0
    state.total = payload.meta ? payload.meta.total : 0
  },
  showFaq (state, payload) {
    state.faq_select.faq = payload
  },
  clearFaqSelect (state, payload) {
    state.faq_select = {
      faq: {},
      comment: []
    }
  },
  getListCommentOfFAQ (state, payload) {
    state.faq_select.comment = payload
  },
  createCommentOfFAQ (state, payload) {
    payload.children = []
    state.faq_select.comment.push(payload)
  },
  destroyCommentOfFAQ (state, payload) {
    var index = lodash.findIndex(state.faq_select.comment, ['id', payload.id])
    state.faq_select.comment.splice(index, 1)
  },
  openReplyComment (state, payload) {
    payload.open_reply = payload.open_reply ? (!payload.open_reply) : true
    var index = lodash.findIndex(state.faq_select.comment, ['id', payload.id])
    state.faq_select.comment.splice(index, 1, payload)
  },
  createChildrenCommentOfChecklistItem (state, payload) {
    var index = lodash.findIndex(state.faq_select.comment, ['id', parseInt(payload.parent_id)])
    state.faq_select.comment[index].children.push(payload)
  },
  destroyChildrenCommentOfFAQ (state, payload) {
    var index = lodash.findIndex(state.faq_select.comment, ['id', parseInt(payload.parent_id)])
    var indexChild = lodash.findIndex(state.faq_select.comment[index].children, ['id', payload.id])
    state.faq_select.comment[index].children.splice(indexChild, 1)
  },
  updateCommentOfFAQ (state, payload) {
    var index = lodash.findIndex(state.faq_select.comment, ['id', payload.id])
    payload.children = state.faq_select.comment[index].children ? state.faq_select.comment[index].children : []
    state.faq_select.comment.splice(index, 1, payload)
  },
  updateChildrenCommentOfFAQ (state, payload) {
    var index = lodash.findIndex(state.faq_select.comment, ['id', parseInt(payload.parent_id)])
    var indexChild = lodash.findIndex(state.faq_select.comment[index].children, ['id', payload.id])
    state.faq_select.comment[index].children.splice(indexChild, 1, payload)
  }
}
// function rederData (item) {
//   var data = {}
//   data.id = item.id
//   data.title = item.title
//   data.is_pin = item.is_pin
//   data.fullname = item.user ? item.user.fullname : ''
//   data.email = item.user ? item.user.email : ''
//   data.group_faq_name = item.group_faq ? item.group_faq.name : ''
//   data.is_resolve = item.is_resolve
//   return data
// }



// WEBPACK FOOTER //
// ./src/store/module/faq/mutations.js